/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ModuleCreatorTemplate from "./moduleCreatorTemplate";
import UserComponent from "./userComponent";

export default class UserComponentCreator extends ModuleCreatorTemplate {
  moduleName = "User Component";
  description = "Imported Custom Component";

  sample = "SampleUserComponent";
  portSizeFixed = false;
  isUserComponent = true;
  pendingModule: UserComponent;
  jsonData: any;

  constructor(jsonData?: any) {
    super();
    this.jsonData = jsonData || null;
    this.pendingModule = new UserComponent([0, 0], "", this.jsonData);
    this.pendingModule.id = "preview";
    
    if (this.jsonData && this.jsonData.name) {
      this.moduleName = this.jsonData.name;
    }

    this.updatePendingModule();
  }

  resetModule(): void {
    UserComponent.count = 0;
    // Reload original JSON to reset properties
    if (this.jsonData) {
      this.pendingModule.loadFromJson(this.jsonData);
    }
    this.pendingModule.updateRender();
  }

  updatePendingModule(): void {
    this.pendingModule.position[1] = 0; // Reset position for preview
    this.pendingModule.updateRender();
  }

  updatePendingModulePosition(pos: number[]): void {
    this.pendingModule.position = [...pos];
    this.pendingModule.updateRender();
  }
}
